<template>
  <div class="register">
    <div class="register-bg">
    </div>
    <div class="register-container">
      <div class="register-area">
        <h2>
          {{$store.getters.sysConfigs['TITLE']}}
        </h2>
        <h1>
          注册新用户
        </h1>
        <div class="padding-top-20"></div>
        <div class="register-box">
          <Form ref="newGuarantorForm" :model="userModel"
            :rules="modelValidate"
            label-position="top">
            <FormItem label="企业名称" prop="displayName">
              <Input v-model="userModel.displayName" placeholder="输入企业名称" />
            </FormItem>
            <FormItem label="登录密码" prop="password">
              <Input v-model="userModel.password" type="password" placeholder="输入登录密码" />
            </FormItem>
            <FormItem label="重复登录密码" prop="rePassword">
              <Input v-model="userModel.rePassword" type="password" placeholder="重复输入登录密码" />
            </FormItem>
            <FormItem label="手机号" prop="mobile">
              <Input v-model="userModel.mobile" placeholder="输入手机号" />
            </FormItem>
            <div class="register-btns">
              <Button type="primary" size="large" long style="width: 200px" @click="register" :disabled="loading">提交</Button>
              <Button type="default" size="large" to="/login?mode=henan">返回登录</Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
    <Footer class="footer" :style="{padding: '5px 0px', color: '#777', fontSize: '12px'}" />
  </div>
</template>

<script>
import Api from '../api/Api'
import Footer from '@/components/Footer'
export default {
  name: 'register-henan',
  components: {
    Footer
  },
  data () {
    const validateRepassword = (rule, value, callback) => {
      if (this.userModel.password && value !== this.userModel.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        if (callback) {
          callback()
        }
      }
    }
    return {
      userModel: {
        companyName: null,
        businessLicense: null,
        legalPersonName: null,
        contact: null,
        contactTel: null,
        displayName: null,
        password: null,
        rePassword: null,
        passwordMd5: null,
        gender: 1,
        loginName: null,
        enabled: true,
        mobile: null,
        email: null,
        type: 3,
        certCn: null,
        roleId: null
      },
      modelValidate: {
        displayName: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请填写密码', trigger: 'blur' }
        ],
        rePassword: [
          { validator: validateRepassword, trigger: 'blur' }
        ]
      },
      loading: false,
      accountApi: null
    }
  },
  mounted () {
    let backImgUrl = this.$store.getters.sysConfigs['WELCOME_BACKGROUND_IMAGE_URL'] || 'bg_01.jpg'
    if (backImgUrl && backImgUrl.toLowerCase().indexOf('http') === 0) {
      backImgUrl = `url(${backImgUrl})`
    } else {
      backImgUrl = `url('/static/'${backImgUrl})`
    }
    document.querySelector('.register').style.backgroundImage = backImgUrl
  },
  methods: {
    async register () {
      this.$refs.newGuarantorForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          this.userModel.loginName = this.userModel.displayName
          this.userModel.passwordMd5 = this.$md5(this.userModel.password)
          await Api.Auth(this).register(this.userModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('注册成功!')
              this.userModel= {
                displayName: null,
                password: null,
                rePassword: null,
                passwordMd5: null,
                gender: 1,
                loginName: null,
                enabled: true,
                mobile: null,
                email: null,
                type: 3,
                certCn: null,
                roleId: null
              }
              this.loading = false
              this.$Spin.hide()
              this.$router.push('/login?mode=henan')
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.register {
  display: flex;
  flex-direction: row;
  height: 100vh;
  background-color: #f2f2f2;
  overflow: hidden;
  color: #efefef;
  background-image: url('./../assets/login_bg_1.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .register-container {
    background-color: rgba(#334458,0.7);
    padding: 16px;
    flex-basis: 38.2%;
    min-width: 352px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .register-area {
      h2 {
        color: lighten(@primaryColor, 20%);
      }
      h1 {
        color: lighten(@secondaryColor, 20%);
      }
    }
    .register-box {
      width: 330px;
      padding: 15px;
      background: #8aa3bd;
      border: 1px solid #999;
      .register-btns {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }
    }
    .ivu-form-item {
      color: #ccc !important;
    }
  }
  .register-bg {
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // background-image: url('./../assets/login_bg_1.jpg');
    // background-repeat: no-repeat;
    // background-size: cover;
  }
  .login {
    width: 330px;
    padding: 15px 0;
    text-align: right;
  }
  .footer {
    position: absolute;
    bottom: 5px;
    left: 5px;
  }
}
</style>
